/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AsCodeDurationDto = {
    timeUnit: AsCodeDurationDto.timeUnit;
    value: number;
};

export namespace AsCodeDurationDto {

    export enum timeUnit {
        DAYS = 'days',
        HOURS = 'hours',
        MINUTES = 'minutes',
    }


}
